import style from './01_banner.css'

export default function TeachersListingBanner() {
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <div className='Teachers-Component-CTA-Banner'>
                <div className='Teachers-Component-CTA-Banner-Details'>
                    <h2>
                        Start your music journey today and connect with a teacher who inspires you.
                    </h2>
                    <div className='Teachers-Component-CTA-Banner-Details-Flex'> 
                        <a href="/teachersregistration">Enroll as a Teacher</a>
                        <a href="/teachers-listing">Start Learning</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
